<template>
    <div class="alertRuleLists">
        <div class="alertRuleLists-title">
            <Breadcrumb>
                <BreadcrumbItem to="/configurationManagement/customerDefinedAlarmConfiguration">{{ $t('configuration_management.customized_alarm_config.customizedAlarmConfig') }}</BreadcrumbItem>
                <BreadcrumbItem>{{ $t('configuration_management.customized_alarm_config.listOfAlarmRules') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="alertRuleLists-top">
            <Row :gutter="4">
                <Col span="4">
                    <Select v-model="accountTypeSearchKey" filterable :placeholder="$t('alarms.common.filterByAccountType')"  @on-change="searchAccountType(accountTypeSearchKey)" :transfer="true">
                        <Option value="-1" >{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
                <Button type="warning" style="float: right;" :loading="modal_loading" @click="exportAlertRuleList" v-hasPermission="['configurationManagement:alertRuleLists:export']">{{ $t('common.export') }}</Button>
            </Row>
        </div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableAlarmRuleColumnDate" style="width: 100.1%;"></Table>
        <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    var tableAlarmRuleColumnVue = {};
    export default {
        name: 'AlertRuleLists',
        data(){
            return {
                companyId: this.$route.query.companyId,
                company: getCookie(global.companyId),
                accountTypeSearchKey:'-1',
                accountTypeList:[],
                current:1,
                dataTotal:0,
                pageSize:10,
                modal_loading:false,
                columns: [
                    {
                        title: this.$t('configuration_management.common.sequenceId'),
                        minWidth: 120,
                        key: 'serialNumber'
                    },
                    {
                        title: this.$t('configuration_management.common.accountType'),
                        minWidth: 150,
                        key: 'accountTypeName'
                    },
                    {
                        title: this.$t('alarms.common.monitorIndex'),
                        minWidth: 150,
                        key: 'monitorIndexName'
                    },
                    {
                        title: this.$t('configuration_management.common.resourceType'),
                        minWidth: 150,
                        key: 'resourceTypeName'
                    },
                    {
                        title: this.$t('configuration_management.common.priority'),
                        minWidth: 80,
                        key: 'customerPriorityName'
                    },
                    {
                        title: this.$t('configuration_management.customized_alarm_config.version'),
                        minWidth: 80,
                        key: 'versionNumber'
                    },
                    // {
                    //     title: this.$t('configuration_management.customized_alarm_config.usingResources'),
                    //     minWidth: 150,
                    //     key: 'usingResources',
                    //     render: (h, params) => {
                    //         return h('a', {
                    //           attrs: {
                    //             href: params.row.usingResources,
                    //           },
                    //           class:{
                    //             usingResources: true,
                    //           }
                    //         }, params.row.usingResources);
                    //     }
                    // },
                    {
                        title: this.$t('configuration_management.customized_alarm_config.alertRuleDesc'),
                        minWidth: 150,
                        key: 'alertRuleDesc'
                    },
                    {
                        title: this.$t('configuration_management.customized_alarm_config.delayName'),
                        minWidth: 150,
                        key: 'delayName'
                    },
                    {
                        title: this.$t('configuration_management.customized_alarm_config.alarmDelayCountdown'),
                        minWidth: 150,
                        key: 'alarmDelayCountdown'
                    },
                    {
                        title: this.$t('configuration_management.customized_alarm_config.isAutoDelayEnroll'),
                        minWidth: 120,
                        fixed: 'right',
                        key: 'isAutoDelayEnroll'
                    }
                ],
                tableAlarmRuleColumnDate: []
            }
        },
        beforeCreate: function() {
            tableAlarmRuleColumnVue = this
        },
        mounted () {
            tableAlarmRuleColumnVue.getAlarmRuleColumnData();
            tableAlarmRuleColumnVue.getAccountType();
        },
        methods: {
            //查询账户类型
            getAccountType: function(){
                this.$api.account.queryCloudPlatforms("userName",getCookie(global.cookieName))
                .then(res => {
                    this.accountTypeList = res.data;
                })
            },
            // 按账户类型筛选
            searchAccountType: function(){
                tableAlarmRuleColumnVue.getAlarmRuleColumnData();
            },
            /*********************分页显示数据*******************************/
            getAlarmRuleColumnData:function() {
                //分页
                this.$api.alertRule.alarmRuleColumn({
                    "type":this.accountTypeSearchKey,
                    "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.tableAlarmRuleColumnDate = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                    for(var i=0;i<this.tableAlarmRuleColumnDate.length;i++){
                        if(this.tableAlarmRuleColumnDate[i].isAutoDelayEnroll==true){
                            this.tableAlarmRuleColumnDate[i].isAutoDelayEnroll=this.$t('common.yes');
                        }else if(this.tableAlarmRuleColumnDate[i].isAutoDelayEnroll==false){
                            this.tableAlarmRuleColumnDate[i].isAutoDelayEnroll=this.$t('common.no');
                        }
                    }
                });
            },
            changePage: function(current){
                this.current=current;
                tableAlarmRuleColumnVue.getAlarmRuleColumnData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableAlarmRuleColumnVue.getAlarmRuleColumnData();
            },
            /***********************导出*****************************/
            exportAlertRuleList: function () {
                this.modal_loading = true
                this.$Message.loading({
                    duration: 0,
                    content: this.$t('configuration_management.customized_alarm_config.exporting')
                })
                // 下载Excel 文件
                this.$api.alertRule.exportAlertRule({
                    "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                    "type": this.accountTypeSearchKey
                })
                .then(res => {
                    let fileName = 'alertRule.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    }else{
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success(this.$t('configuration_management.customized_alarm_config.exportSuccess'));
                })
            }
        }
    }
</script>

<style scoped>
    .alertRuleLists-title
    {
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .alertRuleLists-top
    {
        padding: 4px 0px 15px 0px;
    }
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/AlertRuleLists.vue